// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c17aebd9","977":"04bc9b45"}[chunkId] + ".chunk.js";
};